import React from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Input,
  Label
} from 'reactstrap';
import { useAccount } from 'utils/useAccount';
import { useTranslation } from 'react-i18next';
import { useFilterForm } from 'utils/useFilter';
import moment from 'moment';

function ExportFilter() {
  const { t } = useTranslation();
  const { sources } = useAccount();
  const { values, setValue, apply, isDirty, errors } = useFilterForm({
    defaultValues: {
      from: moment()
        .subtract(3, 'months')
        .startOf('day')
        .format('YYYY-MM-DD'),
      to: moment()
        .endOf('day')
        .format('YYYY-MM-DD')
    },
    requiredValues: ['source', 'from', 'to']
  });

  const handleInputChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    setValue(name, value);
  };

  const onSubmit = async e => {
    e.preventDefault();
    apply();
  };

  return (
    <Card className="card-stats mb-4 mb-xl-0 bg-secondary">
      <CardBody>
        <Row>
          <Col>
            <h4>{t('case.case_filter')}</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="form-control-Label" htmlFor="source">
                {t('filter.source')}
              </Label>
              <Input
                id="source"
                name="source"
                type="select"
                className="form-control-alternative"
                value={values.source || ''}
                onChange={handleInputChange}
              >
                <option value="">-</option>
                {sources &&
                  sources
                    .filter(s => s.hasExports)
                    .map(s => (
                      <option value={s.filterName} key={s.filterName}>
                        {s.name}
                      </option>
                    ))}
              </Input>
              <div className="form-control-feedback pt-1 text-left">
                {errors.source}
              </div>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label className="form-control-Label" htmlFor="from">
                {t('filter.created_from')}
              </Label>
              <Input
                id="from"
                name="from"
                type="date"
                className="form-control-alternative"
                value={values.from || ''}
                max={new Date().toISOString().substring(0, 10)}
                onChange={handleInputChange}
              />
              <div className="form-control-feedback pt-1 text-left">
                {errors.from}
              </div>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label className="form-control-Label" htmlFor="to">
                {t('filter.created_to')}
              </Label>
              <Input
                id="to"
                name="to"
                type="date"
                className="form-control-alternative"
                value={values.to || ''}
                max={new Date().toISOString().substring(0, 10)}
                onChange={handleInputChange}
              />
              <div className="form-control-feedback pt-1 text-left">
                {errors.to}
              </div>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label className="form-control-Label" htmlFor="source">
                {t('filter.export_type')}
              </Label>
              <Input
                className="form-control-alternative"
                type="select"
                name="exportType"
                id="exportType"
                onChange={handleInputChange}
                value={values.exportType || ''}
              >
                <option value=""> -- {t('filter.select')} -- </option>
                <option value="regular">
                  {t('filter.export_types.regular')}
                </option>
                <option value="custom">
                  {t('filter.export_types.custom')}
                </option>
              </Input>
            </FormGroup>
          </Col>
          <Col className="d-flex justify-content-end align-items-center">
            <Button
              color="primary"
              type="submit"
              onClick={onSubmit}
              disabled={!(isDirty && Object.keys(errors).length === 0)}
            >
              {t('filter.apply')}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default ExportFilter;
